import { Obligation, formatObligation } from "@renec-foundation/relend-adapter"
import { PublicKey } from "@solana/web3.js"
import BigNumber from "bignumber.js"
import { atom } from "jotai"
import { atomFamily, atomWithDefault } from "jotai/utils"
import { RawObligationType } from "./shared"
import { solendPoolsFamily } from "./solendPools"

export type ObligationType = Awaited<ReturnType<typeof formatObligation>>

export const solendRawObligationsAtom = atom<{
  [address: string]: RawObligationType
}>({})

export const solendObligationsFamily = atomFamily((address: string) =>
  atom(
    (get) => {
      const rawObligation = get(solendRawObligationsAtom)[address]
      if (!rawObligation?.info) return null

      const pool = get(solendPoolsFamily(rawObligation.info.lendingMarket.toBase58()))

      if (!pool?.reserves.length) return null
      return formatObligation(rawObligation as { pubkey: PublicKey; info: Obligation }, pool)
    },
    (get, set, arg: RawObligationType) => {
      const prev = get(solendRawObligationsAtom)
      set(solendRawObligationsAtom, {
        ...prev,
        [address]: { ...prev[address], ...arg },
      })
    },
  ),
)

export const selectedSolendObligationAddressAtom = atomWithDefault<string | null>(() => {
  if (typeof window !== "undefined") {
    const queryParams = new URLSearchParams(window.location.search)
    const poolParam = queryParams.get("obligation")

    return poolParam
  }

  return null
})

export const selectedSolendObligationAtom = atom((get) => {
  const selectedSolendObligationAddress = get(selectedSolendObligationAddressAtom)
  if (!selectedSolendObligationAddress) return null

  const obligation = get(solendObligationsFamily(selectedSolendObligationAddress))
  if (!obligation) return null

  return obligation
})

export type SolendUSDSObligationListType = {
  obligationAddress: string
  ownerAddress: string
  totalSupplyAmount: BigNumber
}

export type SolendUSDSObligationsStatsType = {
  totalSupplyAmount: BigNumber
  obligations: SolendUSDSObligationListType[]
}

export const solendUSDSObligationsStatsAtom = atom<SolendUSDSObligationsStatsType>({
  totalSupplyAmount: new BigNumber(0),
  obligations: [],
})
